import styled from 'styled-components';

const DetailAddonInfoChannel = styled.div<React.CSSProperties>`
  float: left;
  margin-right: 2%;
  overflow: hidden;
  width: 48%;
`;

export default DetailAddonInfoChannel;
